const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};
function ConvertDDToDMS(D, lng) {
  return {
    dir: D < 0 ? (lng ? "W" : "S") : lng ? "E" : "N",
    deg: 0 | (D < 0 ? (D = -D) : D),
    min: 0 | (((D += 1e-9) % 1) * 60),
    sec: Math.round((0 | (((D * 60) % 1) * 6000)) / 100),
  };
}

function formatPosition(pos) {
  let lat = ConvertDDToDMS(pos.latitude, false);
  let lng = ConvertDDToDMS(pos.longitude, true);
  return `${lat.deg}°${lat.min}'${lat.sec}"${lat.dir} ${lng.deg}°${lng.min}'${lng.sec}"${lng.dir}`;
}

const clone = (object) => {
  if (object == null) return object;
  if (typeof object === "object") {
    if (Array.isArray(object)) {
      let newArray = [];
      object.forEach((item) => newArray.push(clone(item)));
      return newArray;
    } else {
      let newObject = {};
      try {
        let keys = Object.keys(object);
        keys.forEach((key) => (newObject[key] = clone(object[key])));
        return newObject;
      } catch (e) {
        console.error(e);
        return object;
      }
    }
  } else {
    return object;
  }
};

module.exports = {
  getDistanceFromLatLonInKm,
  clone,
  formatPosition,
};
